import React, { useState, useEffect } from "react";
import '../styles.css';

const JeopardyTeam = ({ 
  id,
  name: initialName, 
  points: initialPoints,
  onUpdatePoints,
  onUpdateName
}) => {
  const [teamName, setTeamName] = useState(initialName);
  const [isEditing, setIsEditing] = useState(false);
  const [score, setScore] = useState(initialPoints);

  useEffect(() => {
    setScore(initialPoints);
  }, [initialPoints]);

  useEffect(() => {
    setTeamName(initialName);
  }, [initialName]);

  const startEditing = () => setIsEditing(true);
  
  const saveName = () => {
    setIsEditing(false);
    if (onUpdateName) {
      onUpdateName(id, teamName);
    }
  };
  
  const handleNameChange = e => setTeamName(e.target.value);

  const addPoints = () => {
    if (onUpdatePoints) {
      onUpdatePoints(id, 100);
    } else {
      setScore(prev => prev + 100);
    }
  };
  
  const subtractPoints = () => {
    if (onUpdatePoints) {
      onUpdatePoints(id, -100);
    } else {
      setScore(prev => prev - 100);
    }
  };

  return (
    <div className="team-card fade-in">
      <div className="team-header">
        {isEditing ? (
          <div className="edit-container">
            <input
              type="text"
              value={teamName}
              onChange={handleNameChange}
              className="team-input"
              autoFocus
            />
            <button className="btn btn-save" onClick={saveName}>Uložit</button>
          </div>
        ) : (
          <>
            <h3 className="team-name">{teamName}</h3>
            <span className="team-score">{score} bodů</span>
            <button className="btn btn-edit" onClick={startEditing}>
              <span className="sr-only">Upravit</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 20h9"></path>
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
              </svg>
            </button>
          </>
        )}
      </div>

      <div className="points-controls">
        <button className="btn btn-add" onClick={addPoints}>+100</button>
        <button className="btn btn-subtract" onClick={subtractPoints}>-100</button>
      </div>
    </div>
  );
};

export default JeopardyTeam;